<template>
  <div class="wl-add-product">
    <b-overlay :show="loading" v-if="!is_guest" class="d-inline-block">
      <b-dropdown
        variant="primary"
        class="mb-1 mb-lg-0"
        size="sm"
        split
        :text="buttonText"
        @click="onClick"
      >
        <b-dropdown-item
          @click="addToList(list)"
          v-for="list in editable_lists"
          :key="list.id"
          >Add to '{{ list.list_title | truncate(20) }}'</b-dropdown-item
        >
        <b-dropdown-item
          :href="'/wine-list/new/' + sku"
          v-if="editable_lists.length > 0"
          >Create New Wine List</b-dropdown-item
        >
      </b-dropdown>
    </b-overlay>
    <b-button v-else href="/log-in" variant="primary" size="sm"
      >Log in to Create a Wine List</b-button
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    sku: {
      type: String,
    },
  },
  methods: {
    addToList(list) {
      this.loading = true;
      this.$store.commit("winelist/set_last_added_to", {
        id: list.id,
        list_title: list.list_title,
      });
      this.$store
        .dispatch("winelist/add_to_list", {
          list_id: list.id,
          sku: this.sku,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.showError(
            "Error",
            err.response.data.message ??
              "Sorry, this item couldn't be added to the list. Please try again later."
          ).then(() => {
            this.loading = false;
          });
        });
    },
    onClick() {
      if (!this.last_added_to) {
        window.location = "/wine-list/new/" + this.sku;
      } else {
        this.addToList(this.last_added_to);
      }
    },
  },
  computed: {
    buttonText() {
      if (!this.last_added_to) {
        return "Create new wine list";
      } else {
        return (
          "Add to '" +
          this.$options.filters.truncate(this.last_added_to.list_title, 20) +
          "'"
        );
      }
    },
    ...mapGetters("winelist", ["last_added_to"]),
    ...mapGetters("winelist", ["editable_lists"]),
    ...mapState("user", ["is_guest"]),
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>